<template>
	<div class="brand_box">
		<div class="brand_title">
			运用&nbsp;<i class="el-icon-right"></i>
		</div>
		<dv-border-box-8 :reverse="false">
			<div class="barCart">
				<div id="applyCart1" style="width:100%;height:1.2rem;margin-bottom:0.2rem;"></div>
				<div id="applyCart2" style="width:100%;height:1.2rem;"></div>
			</div>
		</dv-border-box-8>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods:{
			getData(list){
				this.drawCart3(list);
				this.drawCart4(list);
			},
			// 运用-商标质押项目/件数
			drawCart3(list) {
				let myChart = this.$echarts.init(document.getElementById('applyCart1'));
				var option = {
					title:{
						text:'商标质押项目/件数',
						textStyle: {
							color: '#91D5FF',
							fontSize:16,
							fontWeight:'normal',
						},
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					grid: {
						left: '0',
						right: '0',
						top: '20%',
						bottom: '0',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.city),
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show:true,
						},
						axisTick: {		//坐标轴刻度与标签对齐
							alignWithLabel: true,
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					legend: {
						icon: 'rect',
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 24, // 设置间距
						right: '0',
						data: ['项目数', '商标件数'],
						textStyle: {
							color: '#fff',
						},
					},
					series: [{
						name: '项目数',
						type: 'bar',
						barWidth: '30%',
						barGap: '10%',
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						color: [{
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
									offset: 0,
									color: '#0095F2'
								}, // 设置颜色渐变
								{
									offset: 1,
									color: '#00C4F2'
								}
							]
						}, ],
						data:list.map(item =>item.tpledgepro),
					},
					{
						name: '商标件数',
						type: 'bar',
						barWidth: '30%',
						barGap: '10%',
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						color: [{
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
									offset: 0,
									color: '#EB7425'
								}, // 设置颜色渐变
								{
									offset: 1,
									color: '#EDC458'
								}
							]
						}],
						data:list.map(item =>item.tpledgenum),
					}],
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			// 运用-余额亿元
			drawCart4(list) {
				let myChart = this.$echarts.init(document.getElementById('applyCart2'));
				var option = {
					title:{
						text:'商标质押融资金额',
						textStyle: {
							color: '#91D5FF',
							fontSize:16,
							fontWeight:'normal',
						},
					},
					textStyle: {
						color: '#fff',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					grid: {
						left: '0',
						right: '0',
						top:'30%',
						bottom: '0',
						containLabel: true
					},
					legend: {
						data: ["金额亿元"],
						right: 0,
						top: 0,
						textStyle: {
							color: "#fff"
						},
						itemWidth: 10,
						itemHeight: 10,
					},
					color: [{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
								offset: 1,
								color: '#66E1F4'
							}, // 设置颜色渐变
							{
								offset: 0,
								color: '#AEEAF4'
							}
						]
					}, ],
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.city),
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show:true,
						},
						axisTick: {		//坐标轴刻度与标签对齐
							alignWithLabel: true,
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					series: [{
						name: '金额亿元',
						type: 'bar',
						itemStyle: '',
						barWidth: '55%', //柱子粗细
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						data:list.map(item =>item.tpledgemon),
					}]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});				
			},
		}
	}
</script>

<style>
</style>
